import React from 'react'
import {useParams, useHistory} from 'react-router-dom'
import useEffect from 'admin/hooks/useEffect'
import useService from 'admin/hooks/useService'
import useDocument from 'admin/hooks/useDocument'
import useStateObject from 'admin/hooks/useStateObject'
import InputField from 'admin/components/shared/InputField'
import PlanSelect from 'admin/components/shared/PlanSelect'
import Modal from 'admin/components/shared/Modal'
import EditField from 'admin/components/shared/EditField'
import useAccount from '../../hooks/useAccount'
import Map from '../shared/Map'
import Header from '../shared/Header'
import useModal from '../../hooks/useModal'

export default () => {
  const history = useHistory()
  const {organisationID} = useParams()
  const {accountId, popModal} = useModal()
  const {account} = useAccount(organisationID, accountId)
  const {service, errors, create} = useService(organisationID, accountId)
  const [form, setForm, resetForm] = useStateObject({account, accountId: account?.id, ...service})

  useDocument({title: 'Add service'})

  useEffect(() => setForm(service), [service], false)

  const handleCreate = e => {
    create(form, () => handleClose(e))
  }

  const handlePlanSelection = plan => setForm({plan, planId: plan.id})
  const handleCoordsSelection = ({lat, lng}) => setForm({coords: [lat, lng]})

  const handleClose = e => {
    e.preventDefault()
    resetForm(service)
    popModal('new-service')
  }

  return (
    <Modal onClose={handleClose} flashId='new-service'>
      <Header title='Add service'>
        <button className='button is-success' onClick={handleCreate}>
          Add
        </button>
      </Header>
      <section className='section'>
        <div className='container'>
          <div className='field is-grouped'>
            <div className='control is-expanded'>
              <div className='field'>
                <label className='label is-small'>Billing account</label>
                <div className='control'>{form.account?.displayName}</div>
              </div>
            </div>
            <div className='control'>
              <div className='field'>
                <label className='label is-small'>Service plan</label>
                <div className='control'>
                  <PlanSelect
                    buttonText={form.plan && form.plan.name}
                    onChange={handlePlanSelection}
                    errors={errors.internetServicePlanId}
                  />
                </div>
              </div>
            </div>
          </div>
          <InputField
            name='description'
            label='Description'
            placeholder='Sleepout at the back'
            value={form.description || ''}
            onChange={setForm}
            errors={errors.description}
          />
          <EditField
            onChange={setForm}
            values={{ipAddress: form.ipAddress, macAddress: form.macAddress}}
            labels={{ipAddress: 'IP Address', macAddress: 'MAC Address'}}
            placeholders={{ipAddress: '10.10.10.56', macAddress: '78:7B:8A:B2:D8:CB'}}
            errors={{ipAddress: errors.ipAddress, macAddress: errors.macAddress}}
          />
          <div className='field is-grouped'>
            <div className='control is-expanded'>
              <InputField
                type='text'
                name='address'
                placeholder='15 Havill Drive, Awatuna 7882'
                value={form.address || ''}
                onChange={setForm}
                errors={errors.address}
              />
            </div>
            <div className='control is-expanded'>
              <InputField
                type='text'
                name='coords'
                label='Location'
                placeholder='-40.988, 173.771'
                value={form.coords?.join(', ') || ''}
                errors={errors.coords}
                disabled
              />
            </div>
          </div>
          <Map className='field' height='40vh' coords={form.coords} onClick={handleCoordsSelection} />
        </div>
      </section>
    </Modal>
  )
}
